/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'
import ReactTable from 'react-table-legacy'
import { Row, Col, Button } from 'reactstrap'

import ObjectTypeDetail from './ObjectTypeDetail.js'
import { AppContext } from '../../AppContext'

import "react-table-legacy/react-table.css";

class ObjectTypes extends React.Component
{
  objectTypeData = null;

  closeModal()
  {
    this.fetchObjectTypes();

    this.setState(
    {
      isModalOpen: false
    });
  }

  componentDidMount()
  {
    this.fetchRecords();
  }

  constructor(props)
  {
    super();
    this.state =
    {
      isModalOpen: false,
      fileData: [],
      defaultLobTablespace: null,
      buttonsDisabled: true
    }

    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.newObjectType = this.newObjectType.bind(this);
  }

  async fetchAdminProfile()
  {
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'getSystemSettings');
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error retrieving website profile');

    this.setState({defaultLobTablespace: { tablespaceName: result.jsonData.defaultLobTablespace}});
  }

  async fetchObjectTypes()
  {
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'getObjectTypes');
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error retrieving object types');

    this.setState({fileData: result.jsonData.objectTypes});
  }

  fetchRecords()
  {
    this.fetchObjectTypes();
    this.fetchAdminProfile();
  }

  newObjectType()
  {
    this.objectTypeData = 
    {
      objectTypeId: undefined, 
      objectType: '',
      enabled: 'N', 
      tableName: '', 
      columnName: '', 
      tablespaceName: null,
      description: '', 
      htmlAcceptValue: '',
      dataType: 'BLOB',
      fileExtensions: []
    };
    this.setState({isModalOpen: true});
  }

  openModal(objectTypeData)
  {
    this.objectTypeData = objectTypeData;
    this.setState({isModalOpen: true});
  }

  render()
  {
    document.title = this.context.websiteProfile.profileName +  ': Object Types'

    const objectTypeColumns = 
    [
      {Header: 'Object Type', accessor: 'objectType'},
      {Header: 'Table Name', accessor: 'tableName'},
      {Header: 'Data Type', accessor: 'dataType'},
      {Header: 'Description', accessor: 'description'},
      {Header: 'Enabled?', accessor: 'enabled', maxWidth: 100},
      {accessor: 'objectTypeId', show: false},
      {accessor: 'htmlAcceptValue', show: false},
      {accessor: 'columnName', show: false},
      {accessor: 'tablespaceName', show: false},
      {accessor: 'fileExtensions', show: false},
      {accessor: 'vectorModality', show: false},
      {accessor: 'vectorDataEnabled', show: false}
    ]

    return(
      <div>
        <Row style={{paddingTop: "10px"}}>
          <Col sm='2'>
            <Button color="primary" onClick={this.newObjectType}>New Object Type</Button>
          </Col>
          <Col>Double-click on a row to enable and see the details for an object type.</Col>
        </Row>
        <Row style={{paddingTop: "10px"}}>
          <Col sm="6">
            <ReactTable data={this.state.fileData} columns={objectTypeColumns} minRows={1} className="-striped -highlight"
              getTrProps={(state, rowInfo, column) =>
              { 
                if (rowInfo === undefined) return { };
                if (rowInfo.row.enabled === 'Y') return { style: {fontWeight: 'bold'}};
                return { };
              }}
              getTdProps={(state, rowInfo, column, instance) => {
                return {
                  onDoubleClick: (e, handleOriginal) => 
                  {
                    this.openModal(rowInfo.row, false);
                  }
                }
              }}
            />
          </Col>
        </Row>
        {( this.state.isModalOpen && 
          <ObjectTypeDetail  
            isModalOpen={this.state.isModalOpen} closeModal={this.closeModal}
            objectTypeData={this.objectTypeData} defaultLobTablespace={this.state.defaultLobTablespace}
          />
        )}
      </div>
    ); 
  }
}

ObjectTypes.contextType = AppContext;

export default ObjectTypes;